var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"nav"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Препарати")]),_c('router-link',{attrs:{"to":"/courses"}},[_vm._v("Курси")])],1),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }